import { getWallpaper } from '.';

export const getReadyInitialState = (): boolean => {
  return Boolean(getWallpaper());
};

export const getInitializedInitialState = (): boolean => {
  return Boolean(getWallpaper()?.sdkState?.isReady);
};
